import CloseIcon from "@mui/icons-material/Close";
import {
  Alert,
  Autocomplete,
  Button,
  Card,
  CardActions,
  CardContent,
  Collapse,
  Divider,
  IconButton,
  Modal,
  TextField,
  Typography
} from "@mui/material";
import ErrorIcon from "assets/images/warning-2.svg";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { getReportFormatAppSetting } from "services/api/query";
import {
  downloadOptionCSV,
  downloadOptionExcel,
  downloadOptionPdf
} from "utils/constants";
import { popupStyles } from "./Popup.Style";
const initialOptions = [downloadOptionPdf];

const DownloadPopup = ({
  title,
  showPrintModal,
  onCancleClick,
  onDownloadClick,
  setSelectedValue,
  setThrowError,
  throwError,
  throwErrorMessage,
  cfUrl
}) => {
  const { t } = useTranslation();
  const [value, setValue] = useState(downloadOptionPdf);
  const [options, setOptions] = useState(initialOptions);
  const [inputValue, setInputValue] = useState("");

  useEffect(() => {
    if (cfUrl) {
      getReportFormatAppSetting(cfUrl).then((res) => {
        if (!res) {
          return;
        } else {
          let options = [...initialOptions];
          if (res.csv) {
            options.push(downloadOptionCSV);
          }
          if (res.excel) {
            options.push(downloadOptionExcel);
          }
          setOptions(options);
        }
      });
    }
    return () => {
      setValue(initialOptions[0]);
    };
  }, [cfUrl, showPrintModal]);

  return (
    <Modal
      open={showPrintModal}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Card sx={popupStyles.cardStyle}>
        {/* modal header start */}
        <Typography
          variant="h6"
          sx={popupStyles.popupTitle}
          color="text.secondary"
          gutterBottom
        >
          {title}
        </Typography>
        {/* modal header start */}

        <Divider />

        {/* modal content start */}
        <CardContent sx={popupStyles.cardContentStyles}>
          <Collapse in={throwError}>
            {/*Error alert box*/}
            <Alert
              severity="error"
              icon={<img src={ErrorIcon} alt="error" width="20" />}
              sx={popupStyles.alertBox}
              action={
                <IconButton
                  aria-label={t("common.close")}
                  color="inherit"
                  size="small"
                  onClick={() => {
                    setThrowError(false);
                  }}
                >
                  <CloseIcon fontSize="inherit" />
                </IconButton>
              }
            >
              <Typography sx={popupStyles.alertTextStyle}>
                {throwErrorMessage}
              </Typography>
            </Alert>
          </Collapse>
          <Autocomplete
            id="downloadFileType"
            options={options}
            value={value}
            onChange={(event, newValue) => {
              setValue(newValue);
              setSelectedValue(newValue);
            }}
            inputValue={inputValue}
            disableClearable={true}
            onInputChange={(event, newInputValue) => {
              setInputValue(newInputValue);
            }}
            renderInput={(params) => (
              <TextField {...params} label="Export Type" />
            )}
          />
        </CardContent>
        {/* modal content end */}

        <Divider />

        {/* modal footer start */}
        <CardActions sx={popupStyles.cardActionStyles}>
          <Button variant="outlined" onClick={() => onCancleClick()}>
            {t("common.close")}
          </Button>
          <Button variant="contained" onClick={() => onDownloadClick()}>
            {t("common.download")}
          </Button>
        </CardActions>
        {/* modal footer start */}
      </Card>
    </Modal>
  );
};

export default DownloadPopup;
